const MuiOutlinedInput = {
    root: {
        padding: 0,
        fontSize: '.75rem',
        fontWeight: 400,
        width: '100%',
    },
    input: {
        padding: '10px',
    },
    notchedOutline: {
        border: 'none',
    },
};
export default MuiOutlinedInput;
